import React from 'react'

const FfCabin = () => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.33333 3.33464C6.78105 3.33464 6.33333 3.78235 6.33333 4.33464H9.66667C9.66667 3.78235 9.21895 3.33464 8.66667 3.33464H7.33333ZM7.33333 2.66797C6.41286 2.66797 5.66667 3.41416 5.66667 4.33464H3.66667C2.74619 4.33464 2 5.08083 2 6.0013V11.668C2 12.5884 2.74619 13.3346 3.66667 13.3346H12.3333C13.2538 13.3346 14 12.5884 14 11.668V6.0013C14 5.08083 13.2538 4.33464 12.3333 4.33464H10.3333C10.3333 3.41416 9.58714 2.66797 8.66667 2.66797H7.33333ZM6 5.0013H10H12.3333C12.8856 5.0013 13.3333 5.44902 13.3333 6.0013V11.668C13.3333 12.2203 12.8856 12.668 12.3333 12.668H3.66667C3.11438 12.668 2.66667 12.2203 2.66667 11.668V6.0013C2.66667 5.44902 3.11438 5.0013 3.66667 5.0013H6ZM5 7.33463C5 7.15054 5.14924 7.0013 5.33333 7.0013H10.6667C10.8508 7.0013 11 7.15054 11 7.33463C11 7.51873 10.8508 7.66797 10.6667 7.66797H5.33333C5.14924 7.66797 5 7.51873 5 7.33463ZM5 10.0013C5 9.81721 5.14924 9.66797 5.33333 9.66797H10.6667C10.8508 9.66797 11 9.81721 11 10.0013C11 10.1854 10.8508 10.3346 10.6667 10.3346H5.33333C5.14924 10.3346 5 10.1854 5 10.0013Z"
                fill="#1A1A1A"
            />
        </svg>
    )
}

export default FfCabin
